import React from 'react';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import { ModalClose } from '@mui/joy';
import { Box } from '@mui/system';

export interface AndModalProps {
  open: boolean | undefined;
  onClose: (_: boolean) => void;
  children: React.ReactNode;
  modalMode: 'fullscreen' | 'center';
}

export default function AndModal({
  open,
  onClose,
  children,
  modalMode,
}: AndModalProps) {
  return (
    <Modal open={!!open} onClose={onClose}>
      <ModalDialog
        sx={{
          ...(modalMode === 'fullscreen' && {
            maxWidth: '100vw',
            height: '100vh',
          }),
          width: '100vw',
        }}
        layout={modalMode}
      >
        <ModalClose />
        <Box>{children}</Box>
      </ModalDialog>
    </Modal>
  );
}
